import { localize as l } from "../../libs/Localization";

interface IFormTopBar { text: 'SIGN UP' | 'LOGIN' | 'PASSWORD RECOVERY'; title: string };

const FormTopBar = ({ text, title }: IFormTopBar) => {
	return (
		<div id='signUpTopTitle' className='flex flex-row gap-1 m-2'>
			<div className='slanted-box-top text-lg sm:text-xl font-medium bg-red-200 px-4 my-1 py-3 sm:pt-6 select-none'>
				{title ?? <div className='w-24' />}
			</div>
			<div className={`px-2 py-3 font-balloon text-as-shadow select-none place-self-center ${text.length > 8 ? 'text-xl sm:text-4xl' : 'text-4xl sm:text-6xl '}`}>{l[text]}</div>
		</div>
	);
};

export default FormTopBar;
